import type { ElephantProfile, FireworkShow, NavigationMenuItem, PooramEvent } from '@shared/types';

export const HOME_HERO_IMAGE_URL =
  'https://images.pexels.com/photos/3408744/pexels-photo-3408744.jpeg?auto=compress&cs=tinysrgb&w=1200';

export const FALLBACK_POORAMS: PooramEvent[] = [
  {
    id: 'p1',
    slug: 'thrissur-pooram',
    name: 'Thrissur Pooram',
    district: 'Thrissur',
    date: '2027-04-17',
    location: { lat: 10.5276, lng: 76.2144 },
    description: 'Kerala Pooram festival with decorated elephants, percussion ensembles, Kudamattom, and fireworks.',
    imageUrl: '/api/images/img-795b4c78-d3ca-4221-b6e7-b0e20ed07966',
    isLive: false,
    countdownFeatured: true,
  },
  {
    id: 'p2',
    slug: 'nenmara-vallangi-vela',
    name: 'Nenmara Vallangi Vela',
    district: 'Palakkad',
    date: '2027-03-20',
    location: { lat: 10.5917, lng: 76.6025 },
    description: 'A major Palakkad Vela with decorated elephants, percussion, cultural programs, and fireworks.',
    imageUrl: '/api/images/img-pooram-nenmara-vallangi-vela-d9abb604',
  },
  {
    id: 'p3',
    slug: 'arattupuzha-pooram',
    name: 'Arattupuzha Pooram',
    district: 'Thrissur',
    date: '2027-03-05',
    location: { lat: 10.4285, lng: 76.2233 },
    description: 'Known as the Devamela, bringing deities together with elephants, Panchavadyam, and Pandimelam.',
    imageUrl: '/api/images/img-pooram-arattupuzha-pooram-425e5d68',
  },
];

export const FALLBACK_ELEPHANTS: ElephantProfile[] = [
  {
    id: 'e1',
    slug: 'thechikottukavu-ramachandran',
    name: 'Thechikottukavu Ramachandran',
    height: '317 cm',
    owner: 'Thechikottukavu Devaswom',
    history: 'A celebrated Kerala temple elephant known for his Pooram presence.',
    imageUrl: 'https://images.pexels.com/photos/1533947/pexels-photo-1533947.jpeg?auto=compress&cs=tinysrgb&w=800',
  },
];

export const FALLBACK_FIREWORKS: FireworkShow[] = [
  {
    id: 'f1',
    pooramId: 'p1',
    title: 'Vedikkettu Fireworks',
    scheduleTime: '2027-04-30T03:00:00+05:30',
    intensity: 'extreme',
    safetyLevel: 'caution',
    notes: 'Festival fireworks update.',
  },
];

export const FALLBACK_FOOTER_NAV: NavigationMenuItem[] = [
  { id: 'm6', location: 'footer', label: 'Home', path: '/', order: 1, enabled: true, countSource: 'none' },
  { id: 'm7', location: 'footer', label: 'Festival Map', path: '/map', order: 2, enabled: true, countSource: 'none' },
  { id: 'm8', location: 'footer', label: 'Directory', path: '/directory', order: 3, enabled: true, countSource: 'none' },
  { id: 'm15', location: 'footer', label: 'Elephants', path: '/elephants', order: 4, enabled: true, countSource: 'none' },
  { id: 'm10', location: 'footer', label: 'Privacy Policy', path: '/privacy-policy', order: 5, enabled: true, countSource: 'none' },
  { id: 'm11', location: 'footer', label: 'Terms', path: '/terms', order: 6, enabled: true, countSource: 'none' },
  { id: 'm12', location: 'footer', label: 'Cookie Policy', path: '/cookie-policy', order: 7, enabled: true, countSource: 'none' },
  { id: 'm13', location: 'footer', label: 'Disclaimer', path: '/disclaimer', order: 8, enabled: true, countSource: 'none' },
  { id: 'm14', location: 'footer', label: 'Data Deletion', path: '/data-deletion', order: 9, enabled: true, countSource: 'none' },
];
